import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["editor"];
  static values = {
    providers: Array,
  };

  connect() {
    if (this.hasProvidersValue) {
      this.setupMentions();
    }
  }

  setupMentions() {
    this.tribute = new Tribute({
      trigger: "@",
      values: this.providersValue.map((provider) => ({
        key: provider.name,
        value: provider.name,
        id: provider.id,
        avatar: provider.avatar_url,
      })),
      menuItemTemplate: (item) => `
        <div class="flex items-center gap-2">
          ${
            item.original.avatar
              ? `<img src="${item.original.avatar}" class="w-4 h-4 rounded-full">`
              : `<span class="w-4 h-4 rounded-full bg-indigo-100 flex-shrink-0"></span>`
          }
          <span>${item.original.value}</span>
        </div>
      `,
    });

    this.tribute.attach(this.editorTarget);
  }
}
